import {
  CompareMethod,
  Filter,
  FilterMatchingType,
} from "interfaces/filters";

export const filtersDefs: Array<Filter> = [
  {
    name: 'contractLineName',
    path: ['contractLineName', 'providedValue'],
    label: 'Contract Line Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'contractName',
    path: ['contractName', 'providedValue'],
    label: 'Contract Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'contractLineProduct',
    path: ['contractLineProduct', 'providedValue'],
    label: 'Product',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'contractLineAmount',
    path: ['contractLineAmount', 'matchedValue'],
    label: 'Amount',
    matching: FilterMatchingType.NUMBER_COMPARE,
    value: {
      compareMethod: CompareMethod.EQ,
    },
  },
  {
    name: 'contractLineStartDate',
    path: ['contractLineStartDate', 'providedValue'],
    label: 'Start Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractLineEndDate',
    path: ['contractLineEndDate', 'providedValue'],
    label: 'End Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractLineCancelDate',
    path: ['contractLineCancelDate', 'providedValue'],
    label: 'Cancel Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractLineBookingDate',
    path: ['contractLineBookingDate', 'providedValue'],
    label: 'Booking Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractLineRevRecStartDate',
    path: ['contractLineRevRecStartDate', 'providedValue'],
    label: 'Recognition Start Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractLineRevRecEndDate',
    path: ['contractLineRevRecEndDate', 'providedValue'],
    label: 'Recognition End Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractLineCRMID',
    path: ['contractLineCRMID', 'providedValue'],
    label: 'CRM ID',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'contractLineTags',
    path: ['contractLineTags', 'providedValue'],
    label: 'Tags',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'contractLineContractBasedMRRCalc',
    path: ['contractLineContractBasedMRRCalc', 'providedValue'],
    label: 'Contract Based MRR Calc',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
];
